import ReactDOM from 'react-dom/client';
import { TConfig } from './context/ConfigContext';

import App from './App';

let context = (window as any) || {};

context.App = (function () {
  function boostrapApplication(config: TConfig, boostrapElement: any) {
    const root = ReactDOM.createRoot(boostrapElement);

    root.render(<App config={config} />);
  }
  return boostrapApplication;
})();
